import { render, staticRenderFns } from "./addSigningMonthPreferential.vue?vue&type=template&id=4c6546b4&scoped=true&"
import script from "./addSigningMonthPreferential.vue?vue&type=script&lang=js&"
export * from "./addSigningMonthPreferential.vue?vue&type=script&lang=js&"
import style0 from "./addSigningMonthPreferential.vue?vue&type=style&index=0&id=4c6546b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6546b4",
  null
  
)

export default component.exports